const RANKING = [
  { rank: 1, title: '《流浪地球3》', type: '科幻', hot: '🔥 212万', desc: '国产科幻巅峰续作，视觉震撼剧情炸裂' },
  { rank: 2, title: '《繁花》', type: '剧情', hot: '🔥 189万', desc: '王家卫首部电视剧，沪上风情尽收眼底' },
  { rank: 3, title: '《狂飙》', type: '犯罪', hot: '🔥 176万', desc: '年度现象级扫黑剧，张颂文封神之作' },
  { rank: 4, title: '《漫长的季节》', type: '悬疑', hot: '🔥 154万', desc: '豆瓣9.4高分，生活悬疑的巅峰表达' },
  { rank: 5, title: '《奥本海默》', type: '传记', hot: '🔥 132万', desc: '诺兰全新力作，原子弹之父的内心世界' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 text-xs font-medium bg-accent-100 text-accent-700 rounded-full mb-3 whitespace-nowrap">
            热播排行
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading">
            本周热度排行榜
          </h2>
          <p className="text-sm text-foreground-500 mt-2">
            根据播放量与讨论热度综合排名
          </p>
        </div>

        <div className="max-w-2xl mx-auto bg-background-50 rounded-2xl border border-background-200/70 overflow-hidden">
          {RANKING.map((item, i) => (
            <a
              key={i}
              href="#media"
              className={`flex items-center gap-4 p-4 md:p-5 transition-colors cursor-pointer ${
                i < RANKING.length - 1 ? 'border-b border-background-200/50' : ''
              } hover:bg-background-100`}
            >
              <div className={`flex-shrink-0 w-9 h-9 md:w-10 md:h-10 rounded-xl flex items-center justify-center font-bold text-sm font-heading ${
                item.rank === 1
                  ? 'bg-accent-500 text-background-50'
                  : item.rank === 2
                  ? 'bg-primary-500 text-background-50'
                  : item.rank === 3
                  ? 'bg-secondary-500 text-background-50'
                  : 'bg-background-100 text-foreground-500'
              }`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <h3 className="text-sm md:text-base font-bold text-foreground-900 font-heading whitespace-nowrap">
                    {item.title}
                  </h3>
                  <span className="px-2 py-0.5 text-xs bg-secondary-100 text-secondary-700 rounded-md whitespace-nowrap">
                    {item.type}
                  </span>
                </div>
                <p className="text-xs md:text-sm text-foreground-500 mt-1 truncate">
                  {item.desc}
                </p>
              </div>
              <div className="flex-shrink-0 text-xs md:text-sm font-semibold text-accent-600 whitespace-nowrap">
                {item.hot}
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}